'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _join = require('lodash/join');

var _join2 = _interopRequireDefault(_join);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _truncate = require('lodash/truncate');

var _truncate2 = _interopRequireDefault(_truncate);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _applicationState = require('../utils/applicationState');

var _constants = require('../utils/constants');

var _constants2 = _interopRequireDefault(_constants);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _adsSettings = require('../utils/adsSettings');

var _adsSettings2 = _interopRequireDefault(_adsSettings);

var _breakpointUtils = require('../utils/breakpointUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_ERROR_LENGTH = 1000;

var getGuideIdParameter = function getGuideIdParameter(slot) {
  // check input
  if (!slot) {
    return null;
  }

  // don't pass 'i' parameter for DFP unless audio is playing
  var isPassingGuideId = true;
  if (slot.formatDefinition.adProvider === _constants2.default.Networks.dfp && (0, _applicationState.getState)(_applicationState.State.playerStatus) !== _constants2.default.PlayStates.playing && (0, _applicationState.getState)(_applicationState.State.playerStatus) !== _constants2.default.PlayStates.connecting) {
    isPassingGuideId = false;
  }

  var ret = null;
  if (isPassingGuideId) {
    var guideIds = _adsSettings2.default.getNowPlayingGuideIds();
    if (!(0, _isEmpty2.default)(guideIds)) {
      ret = (0, _join2.default)(guideIds, ',');
    }
  }

  return ret;
};

var reporter = {
  request: function request(slot) {
    if (slot && slot.formatDefinition && slot.formatDefinition.reportRequest) {
      var params = this.getParameters(slot);
      this.postReport('r', params);
    }
  },
  impression: function impression(slot) {
    var params = this.getParameters(slot);

    // t parameter is required for impressions
    params.t = -1;

    this.postReport('i', params);
  },
  view: function view(slot) {
    var params = this.getParameters(slot);

    this.postReport('v', params);
  },
  click: function click(slot) {
    var params = this.getParameters(slot);

    this.postReport('c', params);
  },
  fail: function fail(slot, message) {
    if (!(0, _get2.default)(slot, 'formatDefinition.reportError') || !message) {
      return;
    }

    var params = this.getParameters(slot);
    var messageString = (0, _isString2.default)(message) ? message : JSON.stringify(message);

    params.m = (0, _truncate2.default)(messageString, { length: MAX_ERROR_LENGTH });

    // t parameter is required for failures
    params.t = -1;

    this.postReport('f', params);
  },
  start: function start(slot) {
    var params = this.getParameters(slot);

    this.postReport('start', params);
  },
  credit: function credit(slot) {
    var params = this.getParameters(slot);

    this.postReport('unlockcredit', params);
  },
  xButton: function xButton(slot) {
    var params = this.getParameters(slot);

    this.postReport('xbutton', params);
  },
  minimize: function minimize(slot) {
    var params = this.getParameters(slot);

    this.postReport('minimize', params);
  },
  maximize: function maximize(slot) {
    var params = this.getParameters(slot);

    this.postReport('maximize', params);
  },
  skip: function skip(slot) {
    var params = this.getParameters(slot);

    this.postReport('skip', params);
  },
  end: function end(slot) {
    var params = this.getParameters(slot);

    this.postReport('end', params);
  },
  postReport: function postReport(endpoint, params) {
    var api = (0, _applicationState.getState)(_applicationState.State.api);
    _jquery2.default.post({
      url: api.domains.reports + '/reports/a/' + endpoint + '?' + _jquery2.default.param(params),
      // Allow cookies to be sent cross-domain
      // Reference: https://api.jquery.com/jquery.ajax/#jQuery-ajax-settings
      xhrFields: {
        withCredentials: true
      }
    });
  },
  getParamsForSlotList: function getParamsForSlotList(slotList) {
    var _this = this;

    var params = [];
    (0, _forEach2.default)(slotList, function (slot) {
      return params.push(_this.getParameters(slot));
    });

    return params;
  },
  getParameters: function getParameters(slot) {
    var dimensions = void 0;
    switch (slot.medium) {
      case _constants2.default.MediumTypes.display:
        dimensions = (0, _join2.default)(slot.currentDimensions, 'x');
        break;
      case _constants2.default.MediumTypes.video:
        dimensions = 'video';
        break;
      case _constants2.default.MediumTypes.audio:
        dimensions = 'audio';
        break;
      default:
    }

    var params = {
      r: slot.requestId,
      n: slot.formatDefinition.adProvider,
      f: dimensions || 'unknown',
      l: slot.name,
      u: slot.formatDefinition.adUnitId,
      resolution: global.window.innerWidth + ',' + global.window.innerHeight,
      serial: (0, _applicationState.getState)(_applicationState.State.rtid),
      partnerId: (0, _applicationState.getState)(_applicationState.State.partnerId),
      version: (0, _applicationState.getState)(_applicationState.State.version) || '2.0'
    };

    var currentScreen = (0, _applicationState.getState)(_applicationState.State.currentScreen);
    params.s = (0, _join2.default)([currentScreen, (0, _breakpointUtils.getBreakpointName)()], '-');

    var i = getGuideIdParameter(slot);
    if (i) {
      params.i = i;
    }

    var unlockDetails = (0, _applicationState.getState)(_applicationState.State.unlockDetails);
    if (unlockDetails && unlockDetails.CampaignId && _adsSettings2.default.isUnlocked()) {
      params.uc = unlockDetails.CampaignId;
    }

    if (slot.campaignId) {
      params.c = slot.campaignId;
    }

    var userName = (0, _applicationState.getState)(_applicationState.State.userName);
    if (userName) {
      params.username = userName;
    }

    var desktopVersion = (0, _applicationState.getState)(_applicationState.State.desktopVersion);
    if (desktopVersion) {
      params.desktopVersion = desktopVersion;
    }

    return params;
  }
};

module.exports = reporter;